import { Component } from "@angular/core";
import { NbMenuItem, NbMenuService, NbSidebarService } from "@nebular/theme";

@Component({
    selector: 'app-auth',
    templateUrl: 'auth.component.html',
    standalone: false
})
export class AuthComponent {

    constructor() { }
}